'use client';
import React from 'react';
import { useTranslations } from 'next-intl';
import PreScreening from '@/components/PreScreening/PreScreening';
import BrandPageShell from '@/components/BrandPageShell/BrandPageShell';

export default function HomePage() {
  const t = useTranslations('homePage');

  return (
    <BrandPageShell
      title={t('welcomeMessage')}
      subtitle="Complete your prescreening once and we will tailor the rest of the Razee experience around your goals."
      contentMaxWidth={1120}
    >
      <PreScreening />
    </BrandPageShell>
  );
}
